// removed by extract-text-webpack-plugin
module.exports = {"List":"selectionList__List__2mYcQ","ListItem":"selectionList__ListItem__26qVg","Odd":"selectionList__Odd__e09Y6","ErrorText":"selectionList__ErrorText__3HsuX"};


//////////////////
// WEBPACK FOOTER
// ./src/Components/Form/SelectionList/selectionList.css
// module id = 910
// module chunks = 2